module.exports = __webpack_public_path__ + "img/38.2808a2cd.jpg";